import React from "react";

import { IconLockOutlined, IconUnlockOutlined } from "~/components/icon";
import { SkeletonBox } from "~/components/skeleton/box";
import { ZIndexBoundary } from "~/components/z-index-boundary";
import type { Record } from "~/tools/record";

import { Api, type DashboardScope } from "../../common/openapi";
import { Tooltip } from "../react/tooltip/Tooltip";

export interface DashboardScopeIconProps {
	dashboardScope: undefined | DashboardScope;
	variant?: "light" | "dark";
	className?: string;
}

export const DashboardScopeIcon: React.FC<DashboardScopeIconProps> = ({
	dashboardScope,
	variant = "dark",
	...props
}) => {
	const DashboardScopeToIcon = {
		[Api.DashboardScope.PublicDashboard]: {
			tooltip: "Public",
			icon: (
				<IconUnlockOutlined className={variant === "dark" ? "text-gray-800" : "text-gray-100"} height={18} width={18} />
			),
		},
		[Api.DashboardScope.PrivateDashboard]: {
			tooltip: "Private",
			icon: (
				<IconLockOutlined className={variant === "dark" ? "text-gray-600" : "text-gray-500"} height={18} width={18} />
			),
		},
	} satisfies Record<DashboardScope>;

	const { tooltip, icon } = DashboardScopeToIcon[dashboardScope ?? Api.DashboardScope.PrivateDashboard];

	return (
		<SkeletonBox when={dashboardScope} {...props}>
			<ZIndexBoundary zIndex={(closestZIndex = 0) => closestZIndex + 50}>
				{(zIndex) => (
					<Tooltip title={tooltip} zIndex={zIndex}>
						{icon}
					</Tooltip>
				)}
			</ZIndexBoundary>
		</SkeletonBox>
	);
};
